<template>
  <TransitionRoot
    :show="!!message"
    enter="transition transition-opacity transform ease-in-out duration-300"
    enter-from="opacity-0 -translate-y-20"
    enter-to="opacity-100 translate-y-0"
    leave="transition transition-opacity transform ease-in-out duration-300"
    leave-from="opacity-100 translate-y-0"
    leave-to="opacity-0 -translate-y-20"
  >
    <div ref="flashMessage" class="absolute z-20 mt-4 flex w-full px-4">
      <div class="w-full rounded bg-message-green p-4 shadow">
        <div class="flex justify-between">
          <div class="ml-3 flex w-0 flex-1 items-center space-x-2 sm:space-x-4">
            <CheckCircleIcon class="size-6" />
            <p class="text-sm font-medium">{{ message }}</p>
          </div>
          <button class="flex items-center" aria-label="close" @click="close">
            <XIcon class="size-5" />
          </button>
        </div>
      </div>
    </div>
  </TransitionRoot>
</template>

<script setup lang="ts">
  import useFlashMessage from '@/composables/useFlashMessage';
  import { onClickOutside } from '@vueuse/core';
  import { XIcon } from '@heroicons/vue/solid';
  import { CheckCircleIcon } from '@heroicons/vue/outline';
  import { TransitionRoot } from '@headlessui/vue';

  const { message, close } = useFlashMessage();

  const flashMessage = ref<HTMLElement>();

  onClickOutside(flashMessage, close);
</script>
